import React from "react";

function Header(){
    return(
        <div className="heading">
        <h1>To-Do List</h1>
      </div>
    )
}
export default Header;